// BYO API-key management. Keys live in localStorage (the user's own keys, on the
// user's device — never sent to our servers). Used by the Gemini client and the
// optional 3rd-party download API.

const NS = 'qlipper-web:keys';

const read = () => {
  try { return JSON.parse(localStorage.getItem(NS) || '{}'); }
  catch { return {}; }
};

export const getKey = (name) => read()[name] || '';

export const setKey = (name, value) => {
  const all = read();
  if (value) all[name] = value; else delete all[name];
  localStorage.setItem(NS, JSON.stringify(all));
};

export const KEY_NAMES = {
  GEMINI: 'gemini',          // required
  YT_DOWNLOAD: 'ytDownload', // optional, if YT_API.keyMode === 'byo'
  IMAGE_SEARCH: 'imageSearch', // optional, for b-roll image search
};
